export default __webpack_public_path__ + "static/ewallet-for-parking-payment-solutions-c57404f7b45d8611f2a8fb1f5166fdc3.png";